/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripLocationDto2 } from '../../models/camp-trip-location-dto-2';
import { CampTripLocationShowResponse } from '../../models/camp-trip-location-show-response';

export interface PatchCampTripLocationUpdate$Params {
  id: string;
      body: CampTripLocationDto2
}

export function patchCampTripLocationUpdate(http: HttpClient, rootUrl: string, params: PatchCampTripLocationUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripLocationShowResponse>> {
  const rb = new RequestBuilder(rootUrl, patchCampTripLocationUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripLocationShowResponse>;
    })
  );
}

patchCampTripLocationUpdate.PATH = '/v1/camp-trip-location/{id}';
